import { useEffect, useState } from "react";
import axios from "../axios";

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");
  const [amount, setAmount] = useState("");
  const [revenue, setRevenue] = useState(0);

  const fetchAdminData = async () => {
    try {
      const usersRes = await axios.get("/admin/users");
      setUsers(usersRes.data);

      const revenueRes = await axios.get("/admin/revenue");
      setRevenue(revenueRes.data.revenue || 0);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchAdminData();
  }, []);

  const addWallet = async () => {
    if (!userId || !amount) {
      alert("Fill all fields");
      return;
    }

    await axios.post("/admin/add-wallet", {
      user_id: userId,
      amount: Number(amount)
    });

    alert("Wallet Added ✅");
    setUserId("");
    setAmount("");
    fetchAdminData();
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Admin Panel</h1>

      <div className="grid grid-cols-3 gap-6 mb-6">
        <div className="bg-white p-5 rounded-xl shadow">
          <h3 className="text-gray-500">Total Users</h3>
          <p className="text-2xl font-bold mt-2">{users.length}</p>
        </div>

        <div className="bg-white p-5 rounded-xl shadow">
          <h3 className="text-gray-500">Manual Revenue</h3>
          <p className="text-2xl font-bold text-green-600 mt-2">₹{revenue}</p>
        </div>
      </div>

      <div className="bg-white p-5 rounded-xl shadow mb-6">
        <h2 className="text-xl font-semibold mb-4">Add Wallet</h2>

        <div className="flex gap-3">
          <input
            placeholder="User ID"
            className="border p-2 rounded"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />

          <input
            placeholder="Amount"
            className="border p-2 rounded"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />

          <button
            onClick={addWallet}
            className="bg-green-500 text-white px-4 py-2 rounded"
          >
            Add Wallet
          </button>
        </div>
      </div>

      <div className="bg-white p-5 rounded-xl shadow">
        <h2 className="text-xl font-semibold mb-4">Users</h2>

        <table className="w-full text-left">
          <thead>
            <tr className="border-b">
              <th className="py-2">ID</th>
              <th>Email</th>
              <th>Role</th>
              <th>Wallet</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b">
                <td className="py-2">{u.id}</td>
                <td>{u.email}</td>
                <td>{u.role}</td>
                <td>₹{u.wallet}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}